'use strict';

exports.__esModule = true;
exports['default'] = shouldComponentUpdate;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function shouldComponentUpdate(value) {
  return (0, _property2['default'])('shouldComponentUpdate', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/shouldComponentUpdate.js
// module id = 585
// module chunks = 1